import { render, staticRenderFns } from "./SmartTableHeader.vue?vue&type=template&id=436a52ca&scoped=true"
import script from "./SmartTableHeader.vue?vue&type=script&lang=js"
export * from "./SmartTableHeader.vue?vue&type=script&lang=js"
import style0 from "./SmartTableHeader.vue?vue&type=style&index=0&id=436a52ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a52ca",
  null
  
)

export default component.exports